const drawDxfOnCanvas = (dxf: any, canvas: HTMLCanvasElement) => {
  if (canvas) {
    const ctx = canvas.getContext('2d')
    if (ctx) {
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      // Get DXF extents
      const extents = getDxfExtents(dxf)
      const scale = Math.min(
        canvas.width / extents.width,
        canvas.height / extents.height,
      )
      const offsetX = (canvas.width - extents.width * scale) / 2
      const offsetY = (canvas.height - extents.height * scale) / 2

      ctx.setTransform(scale, 0, 0, -scale, offsetX, canvas.height - offsetY)

      // Draw entities from DXF
      dxf.entities.forEach((entity: any) => {
        if (entity.type === 'LINE') {
          ctx.beginPath()
          ctx.moveTo(entity.vertices[0].x, entity.vertices[0].y)
          ctx.lineTo(entity.vertices[1].x, entity.vertices[1].y)
          ctx.stroke()
        } else if (entity.type === 'CIRCLE') {
          ctx.beginPath()
          ctx.arc(
            entity.center.x,
            entity.center.y,
            entity.radius,
            0,
            2 * Math.PI,
          )
          ctx.stroke()
        } else if (entity.type === 'ARC') {
          ctx.beginPath()
          ctx.arc(
            entity.center.x,
            entity.center.y,
            entity.radius,
            entity.startAngle,
            entity.endAngle,
          )
          ctx.stroke()
        } else if (entity.type === 'LWPOLYLINE' || entity.type === 'POLYLINE') {
          ctx.beginPath()
          entity.vertices.forEach((vertex: any, index: number) => {
            if (index === 0) {
              ctx.moveTo(vertex.x, vertex.y)
            } else {
              ctx.lineTo(vertex.x, vertex.y)
            }
          })
          if (entity.closed) {
            ctx.closePath()
          }
          ctx.stroke()
        } else if (entity.type === 'INSERT') {
          drawInsert(ctx, dxf, entity)
        } else if (entity.type === 'MTEXT') {
          drawMText(ctx, entity)
        }
      })
    }
  }
}

const drawInsert = (ctx: CanvasRenderingContext2D, dxf: any, insert: any) => {
  const block = dxf.blocks[insert.name]
  if (block && block.entities) {
    ctx.save()
    ctx.translate(insert.position.x, insert.position.y)
    ctx.scale(insert.scaleX, insert.scaleY)
    ctx.rotate((insert.rotation * Math.PI) / 180)
    block.entities.forEach((entity: any) => {
      drawEntity(ctx, entity)
    })
    ctx.restore()
  }
}

const drawMText = (ctx: CanvasRenderingContext2D, mtext: any) => {
  ctx.font = `${mtext.height}px Arial`
  ctx.fillText(mtext.text, mtext.position.x, mtext.position.y)
}

const drawEntity = (ctx: CanvasRenderingContext2D, entity: any) => {
  if (entity.type === 'LINE') {
    ctx.beginPath()
    ctx.moveTo(entity.vertices[0].x, entity.vertices[0].y)
    ctx.lineTo(entity.vertices[1].x, entity.vertices[1].y)
    ctx.stroke()
  } else if (entity.type === 'CIRCLE') {
    ctx.beginPath()
    ctx.arc(entity.center.x, entity.center.y, entity.radius, 0, 2 * Math.PI)
    ctx.stroke()
  } else if (entity.type === 'ARC') {
    ctx.beginPath()
    ctx.arc(
      entity.center.x,
      entity.center.y,
      entity.radius,
      entity.startAngle,
      entity.endAngle,
    )
    ctx.stroke()
  } else if (entity.type === 'LWPOLYLINE' || entity.type === 'POLYLINE') {
    ctx.beginPath()
    entity.vertices.forEach((vertex: any, index: number) => {
      if (index === 0) {
        ctx.moveTo(vertex.x, vertex.y)
      } else {
        ctx.lineTo(vertex.x, vertex.y)
      }
    })
    if (entity.closed) {
      ctx.closePath()
    }
    ctx.stroke()
  } else if (entity.type === 'MTEXT') {
    drawMText(ctx, entity)
  }
}

const getDxfExtents = (dxf: any) => {
  const extents = {
    minX: Number.POSITIVE_INFINITY,
    minY: Number.POSITIVE_INFINITY,
    maxX: Number.NEGATIVE_INFINITY,
    maxY: Number.NEGATIVE_INFINITY,
  }

  dxf.entities.forEach((entity: any) => {
    if (entity.vertices) {
      entity.vertices.forEach((vertex: any) => {
        if (vertex.x < extents.minX) extents.minX = vertex.x
        if (vertex.y < extents.minY) extents.minY = vertex.y
        if (vertex.x > extents.maxX) extents.maxX = vertex.x
        if (vertex.y > extents.maxY) extents.maxY = vertex.y
      })
    }
    if (entity.center) {
      if (entity.center.x - entity.radius < extents.minX)
        extents.minX = entity.center.x - entity.radius
      if (entity.center.y - entity.radius < extents.minY)
        extents.minY = entity.center.y - entity.radius
      if (entity.center.x + entity.radius > extents.maxX)
        extents.maxX = entity.center.x + entity.radius
      if (entity.center.y + entity.radius > extents.maxY)
        extents.maxY = entity.center.y + entity.radius
    }
  })

  return {
    width: extents.maxX - extents.minX,
    height: extents.maxY - extents.minY,
    minX: extents.minX,
    minY: extents.minY,
  }
}

export { drawDxfOnCanvas }
